/**
 * @file src/components/molecules/InfoAlert/InfoAlert.tsx
 * @description Customized alert component for displaying informational messages.
 * @module InfoAlert
 */

import React, { FC } from 'react';
import { Alert } from '@/components';
import { AlertProps } from '@/interfaces';

const InfoAlert: FC<AlertProps> = (props) => {
  return <Alert {...props} />;
};

export default InfoAlert;
